<template>
  <el-select
    v-model="productModel"
    @change="productChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.PRODUCT')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled || loading"
    remote
    :remote-method="getProducts"
    :loading="loading"
  >
    <el-option v-if="showAll" :value="null" :label="$t('COMMON.PRODUCT')">
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')">
    </el-option>
    <el-option
      v-for="product in products"
      :key="product.id"
      :value="product.id"
      :label="`${product.code} - ${product.name}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "purchases-order-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    product: {
      type: String,
      default: null,
      description: "Product id",
    },
    /** we use product and product object because we have multiple kind of products : supplier-products, warehouse-products, products */
    productObject: {
      type: Object,
      default: null,
      description: "Product object must have a field product",
    },
    filterReseller: {
      type: String,
      default: null,
      description: "Reseller id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterWarehouse: {
      type: String,
      default: null,
      description: "Warehouse id",
    },
    filterSupplier: {
      type: String,
      default: null,
      description: "Supplier id",
    },
    filterIds: {
      type: Array,
      default: null,
      description: "products ids",
    },
  },

  data() {
    let productModel = null;
    if (this.product) {
      productModel = this.product;
    } else if (this.productObject) {
      productModel = this.productObject.product_id;
    }
    return {
      productModel: productModel,
      products: {},
      loading: false,
    };
  },

  setup() {},

  created() {
    if (this.product) {
      this.getProducts(null, this.product);
    } else if (this.productObject) {
      this.getProducts(null, this.productObject.product_id);
    }
  },

  methods: {
    async getProducts(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "-created_at",
          filter: {
            ...(query ? { search: query } : {}),
            ...(id ? { id: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }
        if (this.filterReseller) {
          params = {
            ...params,
            filter: { ...params.filter, reseller: this.filterReseller },
          };
        }
        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.filterSupplier) {
          params = {
            ...params,
            filter: { ...params.filter, supplier: this.filterSupplier },
          };
        }
        if (this.filterWarehouse) {
          params = {
            ...params,
            filter: { ...params.filter, warehouse: this.filterWarehouse },
          };
        }
        if (this.filterIds) {
          params = {
            ...params,
            filter: { ...params.filter, ids: this.filterIds },
          };
        }

        await this.$store.dispatch("products/list", params);
        const productsArr = await this.$store.getters["products/list"];
        this.products = {};
        productsArr.forEach((product) => {
          this.products[product.id] = product;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    productChanged(productId) {
      const product = Object.values(this.products).find(
        (item) => item.id === productId
      );
      this.$emit("productChanged", productId, product);
    },
  },

  watch: {
    product(product) {
      if (product) {
        if (product !== this.productModel) {
          this.getProducts(null, product);
        }
        this.productModel = product;
      } else {
        this.productModel = null;
      }
    },
    productObject(productObject) {
      if (productObject) {
        if (productObject.product_id !== this.productModel) {
          this.getProducts(null, productObject.product_id);
        }
        this.productModel = productObject.product_id;
      } else {
        this.productModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getProducts();
    },
    filterReseller(filterReseller) {
      this.getProducts();
    },
    filterSupplier(filterSupplier) {
      this.getProducts();
    },
    filterWarehouse(filterWarehouse) {
      this.getProducts();
    },
    filterIds(filterIds) {
      this.getProducts();
    },
  },
};
</script>
